/** The colours and type a Chart.js chart needs, in the form Chart.js takes them. */
export interface ChartTheme {
  /** One colour per series, in the order the chart adds them: --sdr-chart-1 … --sdr-chart-4. */
  series: string[];
  grid: string;
  text: string;
  font: string;
}

/** Reads a CSS custom property; in the browser, from the document's computed style. */
export type TokenReader = (name: string) => string;

/**
 * The chart's colours and type, taken from the theme tokens in tailwind.css.
 *
 * Chart.js draws on a canvas, which CSS never reaches, so a chart has to be
 * told its colours. Reading them from the tokens keeps it in step with the
 * rest of the app in light, dark and high contrast.
 */
export function chartTheme(read: TokenReader): ChartTheme {
  const token = (name: string) => read(name).trim();
  return {
    series: [1, 2, 3, 4].map(n => token(`--sdr-chart-${n}`)).filter(Boolean),
    grid: token('--sdr-line'),
    text: token('--sdr-ink-subtle'),
    font: token('--font-sans'),
  };
}

/** The tokens as the document currently resolves them (light, dark or high contrast). */
export const documentTokens: TokenReader = name => getComputedStyle(document.documentElement).getPropertyValue(name);
